import { Box } from "@mui/material";
import React from "react";
import "./styles.scss";

const PinterestStack = ({ children }) => {
  return <Box className="pin_container">{children}</Box>;
};

export default PinterestStack;
